import type { AppRouteRecordRaw } from '@/router/types'

export const systemSafeMangeRoutes: AppRouteRecordRaw[] = [
  {
    path: 'systemSafeMange',
    name: 'SystemSafeMange',
    component: () => import('@/views/systemSafeMange/index.vue'),
    meta: { title: '系统安全配置' },
    children: [
      {
        path: 'usageRulesMange',
        name: 'UsageRulesMange',
        component: () => import('@/views/systemSafeMange/usageRulesMange/index.vue'),
        meta: { title: '使用规则配置' }
      },
      {
        path: 'loginTimeLimitMange',
        name: 'LoginTimeLimitMange',
        component: () => import('@/views/systemSafeMange/loginTimeLimitMange/index.vue'),
        meta: { title: '登录时限配置' }
      },
      {
        path: 'logonUserMange',
        name: 'LogonUserMange',
        component: () => import('@/views/systemSafeMange/logonUserMange/index.vue'),
        meta: { title: '登录用户配置' }
      },
      {
        path: 'systemWatermarkerMange',
        name: 'SystemWatermarkerMange',
        component: () => import('@/views/systemSafeMange/systemWatermarkerMange/index.vue'),
        meta: { title: '系统水印配置' }
      }
    ]
  }
]
